/**
 * Create by lizj 2018/6/15
 */


;(function () {

    dialogCondDelCtrl.$inject = ['event', 'request'];
    angular
        .module('DSSXAPP')
        .component('dialogCondDel', {
            template:'<div class="dialog-cond-del-component" ng-show="vm.d.showDialogCondDel"><div class="dialog-cond-del-wrap"></div><div class="dialog-cond-del zoomIn" ng-style="vm.d.style"><div class="dialog-cond-del-title"><i class="iconfont icon-close" ng-click="vm.f.cancel()"></i><div ng-show="vm.d.dataLen">重要提醒</div><div ng-show="!vm.d.dataLen">提醒</div></div><div class="dialog-cond-del-content"><div class="condition" ng-show="vm.d.dataLen">您选择<span class="bold-action">一键批量删除</span>满足如下条件的零效果产品（共计{{vm.d.total}}个）：<br><ul class="bold-action"><li ng-repeat="item in vm.d.list" ng-bind="item.key + \': \' + item.val"></li></ul></div><div class="notice" ng-show="vm.d.dataLen"><span class="notice-title">温馨提示：</span>满足条件的产品将在您确认删除后开始删除，一旦删除将不可恢复，请再次确认。</div><div ng-show="!vm.d.dataLen">没有满足您所选条件的产品可供删除，请重新选择。</div></div><div class="dialog-cond-del-footer" ng-show="vm.d.dataLen"><button class="button-primary button-medium sure" ng-click="vm.f.sure()">删除</button> <button class="button-normal button-medium cancel" ng-click="vm.f.cancel()">取消</button></div><div class="dialog-cond-del-footer" ng-show="!vm.d.dataLen"><button class="button-primary button-medium sure" ng-click="vm.f.cancel()">确定</button></div></div></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: dialogCondDelCtrl
        });

    function dialogCondDelCtrl(event, request) {
        this.$onInit = onInit;

        var vm = this;

        vm.d = {
            showDialogCondDel: false,
            ids: [],
            dataLen: 0,
            list: [],
            style: {},
            total: 0,
        };

        vm.f = {
            sure: sure,
            cancel: cancel
        };

        function onInit() {
            initEvent();
        }

        function initEvent() {
            event.on('layout.showDialogCondDel', function (data) {
                vm.d.showDialogCondDel = data.type;
                vm.d.dataLen = data.dataLen;
                if (vm.d.dataLen) {
                    vm.d.style = {width: '600px'};
                } else {
                    vm.d.style = {width: '400px'};
                }
                vm.d.list = [];
                angular.forEach(data.list, function (v) {
                    if (v.val) {
                        vm.d.list.push({
                            key: v.key,
                            val: v.val,
                            num: v.num || 0
                        });
                    }
                });
                vm.d.total = data.total
            })
        }

        function sure() {
            var config = {
                cond: {
                    invalidTime: 0,
                    productName: ''
                },
                method: 'delByCond'
            };

            angular.forEach(vm.d.list,function (v) {
               if(v.key === '无效时长'){
                   config.cond.invalidTime = v.num;
               }
               if(v.key === '产品名称'){
                   config.cond.productName = v.val;
               }
            });

            updateZeroEffectPrd(config)
            cancel();
        }

        function cancel() {
            vm.d.showDialogCondDel = false;
        }

        //跟新零效果产品
        function updateZeroEffectPrd(data) {
            request.post('/usr/api/updateZeroEffectPrd', {}, data, true)
                .then(updateSuc, updateErr)
            ;

            function updateSuc(res) {
                if (res.code === 0) {
                    layer.msg('删除成功', {icon: 1});
                }
                ZeroEffectProductTMInterpolator()
                event.emit('reset-success');
            }

            function updateErr(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'dialogDelCtrl',
                    funcName: 'updateZeroEffectPrd',
                    text: 'dialogDelCtrl fail'
                });
            }
        }

        // 实训任务-零效果产品页插入逻辑
        function ZeroEffectProductTMInterpolator() {
            var TM = DSSX.TrainingMission;

            return TM.tryStart(TM.MissionType.ZeroEffectProduct, {bindId: '', bindInfo: ''})
                .then(tryStartTMSuc, tryStartTMErr);

            function tryStartTMSuc(tmc) {
                console.log('[inqChatCtrl] TM tmc: ', tmc);
                // 没有任务需要同步或同步失败
                if (!tmc) {
                    // do something
                }
            }

            function tryStartTMErr(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'SelfProductCtrl',
                    funcName: 'tryStart',
                    text: '实训任务错误',
                });
                console.log('[TM] tryStartTMErr', err);
            }
        }

    }

})();

